import { Box } from "@mui/material"
import { borderRadius, fontWeight, maxHeight, styled, width } from "@mui/system"

const HeaderStyle = {
    appbar: { position: "static", backgroundColor: '#0f1a2b' },
    toolbar: { justifyContent: 'space-between' },
    box: { display: "flex", alignItems: "center" },
    img: { height: '30px', marginRight: '10px' },
    box1: { display: { xs: 'none', md: 'flex' }, alignItems: "center", gap: 2 },
    link: { textTransform: 'none', fontWeight: 'bold', fontSize: "16px" },
    iconbox: {
        display: { xs: 'flex', md: 'none', maxWidth: "100%" }, // Show only on small screens
    }
}

const FooterStyle = {
    bg: {
        backgroundColor: '#00cfe8',
        color: '#000',
        textAlign: 'center',
        py: 2,
    }
}

const Footer2Style = {
    box: {
        color: '#000',
        px: 4,
        mb: 2
    },
    outergrid: {
        display: "flex", flexDirection: { xs: "column", md: 'row' },
        spacing: 2, alignItems: "center", justifyContent: "space-between",
        py: 4,
        borderTop: '1px solid #e0e0e0',
    },
    img: { height: '30px', marginRight: '10px' },
    grid2: { flexBasis: "33%", display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: { xs: "column", md: 'row' }, mt: { xs: 5, md: 0 } },
    typo: { fontWeight: 'bold', color: "rgba(0, 0, 0, 0.50)" },
    align: { pt: 0.5, color: "#717B7C" },
    bold: { fontWeight: 'bold' },
    bottom: { textAlign: { xs: 'center', sm: 'right' }, borderTop: '1px solid #e0e0e0', display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: 'row' } },
    copyright: { mt: 2, color: '#666', fontWeight: 300 },
    link: { mx: 1, fontSize: '0.9rem', color: '#0047A4' },
    seperator: { fontSize: '0.9rem', color: '#666' }
}

const LoginStyle = {
    box: { display: "flex", justifyContent: { xs: "center", md: "space-between" }, width: { xs: "100%", md: "95vw" }, minWidth: { sm: "950px" } },
    leftbox: {
        display: { xs: 'none', md: 'block' }, // Hide on mobile
        width: { xs: '100%', md: "65%" }, // Adjust as needed
    }
}

const LeftimgStyle = {
    box: { bgcolor: "#07D6E5", borderRadius: '15px', display: "flex", justifyContent: "center", minWidth: "33%", m: 4, filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25))' }
}
const middleBoxStyle = (width, selectedType, cart) => {
    return {
        box: { bgcolor: "white", display: "flex", flexDirection: 'column', alignItems: "center", borderRadius: "15px", width: width, m: 2, mt: 4, mb: 4, p: 7, pr: { xs: "15px", md: 7 }, pl: { xs: "15px", md: 7 }, filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25))', },
        box2: { bgcolor: "white", borderRadius: "15px", width: width, m: 1, mt: 4, mb: 4, p: 4, filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25))', width: "85%" },
        innerbox: { p: 2, display: "flex", flexDirection: 'column', alignItems: "center" },
        heading: { fontWeight: "bold", textAlign: "center", fontFamily: "'Aller', sans-serif" },
        divider: { borderColor: "black", width: '10%', display: "flex", justifyContent: "center", mt: 2 },
        box1: { mt: 5, width: { xs: "90%", lg: "85%" } },
        grid: { flexBasis: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
        grid1: { display: "flex", justifyContent: "center" },
        innergrid: { flexBasis: { xs: "20%", md: "10%" }, pb: "25px" },
        resendbtn: {
            cursor: 'pointer',
            textDecoration: 'underline',
            textAlign: "center",
            textTransform: "none"
        },
        input: {
            backgroundColor: "white",
            pb: "25px",
            "&:hover": {
                backgroundColor: "#f5f5f5",
            },
            "&.Mui-focused": {
                backgroundColor: "#ffffff",
            },
        },
        typo: { fontWeight: "bold" },
        typegrid: { marginBottom: 5, display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", sm: "row" }, ml: { xs: 0, md: 1 }, mr: { xs: 0, md: 1 }, mt: 3, width: { xs: "100%", md: cart ? "96%" : "85%" } },
        typeinnergrid: { flexBasis: "46%" },
        paper: {
            padding: 2,
            textAlign: 'center',
            cursor: 'pointer',
            border: selectedType === 'company' ? '2px solid #000814' : 'none',
            borderRadius: "15px",
            '&:hover': {
                boxShadow: 4,
            },
        },
        outerTypo: { fontWeight: "bold", textAlign: "left", lineHeight: "1.4em" },
        span: { fontWeight: "400" },
        text: { fontSize: "18px", width: { xs: "80%", md: "100%" }, textAlign: 'center' },
        btnbox: { width: { xs: "100%", md: "85%" } }

    }
}
const input = {
    card: {
        borderRadius: '10px',
        width: "100%",
        filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25))',
        bgcolor: "white"
    },
    text: {
        height: '44px',
        alignContent: 'center',
        p: 0,
        display: 'inline-grid',
        '& input[type=number]': {
            '-moz-appearance': 'textfield',
            '&::-webkit-outer-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0,
            },
            '&::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0,
            },
        },
        "&.MuiOutlinedInput-root": {
            borderRadius: '10px',
            height: '44px',
            alignContent: 'center',
            display: 'inline-grid',
            p: 0,
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                p: 0,
                bordeRadius: "50px",
                borderColor: "transparent", // Removes the border
            },
            "&:hover fieldset": {
                borderColor: "transparent", // Removes the border on hover
            },
            "&.Mui-focused fieldset": {
                borderColor: "transparent", // Removes the border when focused
            },
        },
        "&.css-2u11ia-MuiInputBase-input-MuiOutlinedInput-input": {
            p: 0
        }

    },
    text1: {
        bgcolor: "#F0F0F0",
        height: '41px',
        borderRadius: '15px',
        pt: 0,
        width: "100%",
        "&.MuiOutlinedInput-input": {
            pt: 0,
            width: "100%"
        },

        "& .MuiOutlinedInput-root": {
            pt: 0,
            height: "41px",
            width: "100%",
            "& fieldset": {
                pt: 0,
                borderColor: '#0E1C29',
                height: '44px',
                borderRadius: '15px',
            },
            "&:hover fieldset": {
                borderColor: "#0E1C29", // Removes the border on hover
            },
            "&.Mui-focused fieldset": {
                borderColor: "#0E1C29", // Removes the border when focused
            },
        },


    },
    box: {
        borderRadius: '15px',
        borderColor: '#0E1C29',
        color: "black",
        width: "90%"

    },
    search: { color: "#CCD4D6", mr: 1 },
    adorn: {
        marginRight: 1,
        paddingLeft: 1,
        fontSize: 16,
        color: 'black',
        borderRight: '2px solid #CCC',
        paddingRight: '18px'
    }

}
const btnstyle = (color, textcolor) => {
    return {
        btn: {
            backgroundColor: color,
            color: textcolor,
            textTransform: "none",
            borderRadius: "10px",
            fontFamily: "'Aller', sans-serif",
            padding: "10px 16px",
            '&:hover': {
                backgroundColor: color,
            },
        }
    }
}
const backbtn = {
    box: { display: 'flex', alignItems: 'center', marginBottom: 2 },
    Typo: { marginLeft: 1, fontSize: '18px' }
}
const profileStyle = (img) => {
    return {
        outerbox: { m: 5, minHeight: { xs: 'calc(100vh - 187px)', md: 'calc(100vh - 197px)' }, width: "95%", maxWidth: { xs: "315px", sm: "100%" } },
        imagebox: { backgroundRepeat: 'no-repeat', backgroundSize: 'cover', minHeight: "60px", maxHeight: "60px", backgroundColor: '#000814', padding: 3, pl: 5, cursor: "pointer", color: 'white', borderRadius: '10px', display: 'flex' },
        avatar: { width: 60, height: 60, backgroundColor: 'white', color: '#000814' },
        icon: { position: "absolute", top: { xs: "110px", md: "121px" }, left: '50px' },
        name: { ml: 7 },
        desc: { color: 'lightgray' },
        tabs: { boxShadow: "0px 0px 20px 0px rgba(115, 115, 115, 0.16)", borderRadius: "10px 10px 0px 0px", mt: 3 },
        tab: { mr: { xs: "10px", md: "50px" }, textTransform: "none", },
        tabactive: {
            '& .MuiTabs-indicator': {
                backgroundColor: '#07D6E5', // Custom indicator color
                color: 'black', // Unselected tab text color
                fontWeight: 600
            },
            '& .MuiTab-root': {
                color: 'black', // Unselected tab text color
                fontWeight: 600
            },
        },
        status: {
            borderRadius: '10px',
            border: "1px solid #C8C8C8",
            background: '#F4F4F4',
            height: "40px",
            width: "150px",
            mr: 2,
            mt: 1,
            mb: 1
        },
        statusbox: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center"
        }
    }
}

const InfoStyle = {
    grid: { display: 'flex', justifyContent: "space-between" },
    text: {
        width: { xs: "30%", md: "35%" },
        '& .MuiInputBase-input': {
            padding: 0, // Removes padding inside the input field
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "transparent", // Removes the border
                padding: 0,
            },
            "&:hover fieldset": {
                padding: 0,
                // borderColor: "transparent", // Removes the border on hover
            },
            "&.Mui-focused fieldset": {
                borderColor: "transparent", // Removes the border when focused
                padding: 0,
            },
        }
    }
}

const buymaterial = {
    box: { display: "block", width: "100%", justifyContent: "center", minHeight: { xs: 'auto', md: 'calc(100vh - 118px)' }, maxHeight: { xs: 'auto', md: '110vh' }, bgcolor: "#F9FAFE" },
    box1: { flex: 1, display: "flex" },
    cartbox: {
        boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.25)",
        display: { xs: "none", lg: "flex" },
        bgcolor: '#F4F7F8',
        width: '36%',
        padding: 1.7,
    }
}


const sidebar = (openCategory, opensubCategory, index, subIndex) => {
    return {
        box: {
            minWidth: '285px', maxHeight: { xs: "inherit", lg: "79.7vh" }, backgroundColor: '#192C3E', color: 'white', padding: 2, overflow: "scroll",
            boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.25)", height: { xs: "inherit" }
        },
        listitem: { color: 'white', cursor: 'pointer', bgcolor: openCategory === "All Products" && 'grey' },
        listitem1: { color: 'white', cursor: 'pointer', bgcolor: openCategory === index && 'grey' },
        listicon: { color: 'white', minWidth: '35px' },
        listimg: { width: '20px' },
        sublist: { color: 'white', cursor: 'pointer', pl: 4, bgcolor: opensubCategory === subIndex && 'grey' }
    }
}

const products = {
    box: { width: "100%", bgcolor: '#F9FAFE', p: 5, maxWidth: { xs: "294px", sm: "700px", md: "1000px", lg: "800px" }, minHeight: "auto", maxHeight: { xs: "auto", lg: "73vh" }, overflow: { xs: "none", lg: "scroll" } },
    search: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 },
    typo: {
        color: '#838A8C',
        fontFamily: 'Aller',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '27px',
        ml: 1
    },
    filter: {
        display: 'flex',
        overflowX: 'auto', // Enable horizontal scrolling
        whiteSpace: 'nowrap', // Prevent text wrapping
        padding: 1,
        gap: 2 // Add spacing between buttons
    },
    filterbtn: {
        minWidth: "auto",
        borderRadius: '10px',
        background: '#FFF',
        fontFamily: 'Aller',
        fontSize: '16px',
        fontWeight: 400,
        fontStyle: 'normal',
        color: 'black',
        whiteSpace: 'nowrap', // Prevent button text from wrapping
        textTransform: 'none', // Preserve case of the text
    },
    emptybox: { display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "48vh" },
    empty: { fontWeight: 700, fontSize: "20px" },
    productbox: { textAlign: 'center', padding: 2, display: "flex", flexDirection: "column", alignItems: "center" },
    imgbox: { textAlign: 'center', mb: 2, bgcolor: "#F4F7F8", borderRadius: "50%", width: { xs: "100px", md: "200px" }, height: { xs: "100px", md: "200px" }, display: "flex" },
    img: { borderRadius: "50%", width: "100%" },
    btn: {
        borderRadius: '10px', border: '1px solid #E6E6E6', background: '#FFF', fontFamily: 'Aller',
        fontSize: '16px', color: "#0047A4",
        fontStyle: 'normal', fontWeight: 700, textTransform: "none"
    },
    pagination: { width: "100%", display: "flex", justifyContent: "flex-end" },
    btnbox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    cashbackbox: { display: "flex", alignItems: "center", background: "blanchedalmond", p: { xs: 0.5, md: 1 }, borderRadius: "10px", position: "relative", bottom: "42px" },
    cashbacktypo: { fontSize: { xs: "12px", md: "14px" } },
    name: { fontWeight: 700, fontSize: { xs: "14px", md: '18px' } },
}

const productsdetails = {
    modal: {
        display: "flex", justifyContent: "center",
        alignItems: "center", overflow: "scroll"
    },
    box: {
        width: { xs: 350, md: 500 },
        backgroundColor: 'white',
        borderRadius: 2,
        boxShadow: 24,
        margin: 'auto',
        outline: 'none',
    },
    imgbox: {
        display: "flex",
        justifyContent: "center",
        marginBottom: 2,
        width: "100%",
        bgcolor: "rgb(243, 245, 245)"
    },
    img: {
        height: '250px',
        width: '100%',
        borderRadius: 5,
    },
    innerbox: { p: 3 },
    typo: { textAlign: 'start', marginBottom: 2, fontWeight: 700 },
    label: { fontWeight: 600, textTransform: "capitalize", },
    valid: { color: "#FF0202", },
    closebtn: { fontWeight: 700, fontSize: "20px", color: "black" },
    iconbox: { display: "flex", width: "100%", justifyContent: "flex-end" },
    icon: { position: "absolute" },
    qtybox: { mt: 2, mb: 2 },
    inputbox: { display: "flex" },
    unitbox: { display: "flex", justifyContent: "center", alignItems: "center", ml: 1 },
    divider: { width: "15%" }
}

const select = {
    input: {
        borderRadius: '10px',
        fontSize: '16px',
        width: '100%',
        fontWeight: 400,
        backgroundColor: '#F0F0F0',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0E1C29',
        },
        '& .MuiSelect-select': {
            padding: '8px',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0E1C29',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0E1C29',
        },
    }
}
const empty = {
    box: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", p: 3 },
    text: { fontSize: "22px", mt: 1 },
    text1: { fontSize: "16px", mt: 1 },
    btn: { width: { xs: "50%", md: "10%" }, mt: 1 }
}
const viewcart = {
    btn: {
        position: 'fixed',
        bottom: '0%',
        left: '50%',
        width: "90%",
        height: "2%",
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#0f1a2b',
        border: '2px solid #000',
        color: "white",
        boxShadow: 24,
        padding: 4,
        textTransform: "none",
        gap: "30px",
        zIndex: 99
    },
    modal: { display: "flex", justifyContent: "center", p: 3, bgcolor: "white", zIndex: 99999999999 },
    typo: { border: "1px solid white", p: "6px 12px" },
    icon: {
        position: "absolute", right: "0px", cursor: "pointer", zIndex: 999999
    }
}
const order = {
    container: { maxWidth: '100%', overflowX: 'auto' },
    box: { display: "flex", width: "35%", alignItems: "center" },
    typo: { ml: 2 },
    cell: { minWidth: "100px" },
    desc: { fontSize: "14px" },
    pagi: { width: "98%", display: "flex", justifyContent: "flex-end", p: 2 }
}

const cart = (Orderlist, rfq) => {
    return {
        box: { textAlign: "center", display: "flex", maxHeight: { sm: "100vh", md: "75vh" }, alignItems: "center", width: "100%", flexDirection: "column", width: "100%", position: "relative" },
        typo: { pt: '16px', fontWeight: 'bold', color: '#333', mb: !Orderlist?.length && rfq === undefined ? 10 : 3 },
        noprod: { fontWeight: 600, mt: 2 },
        desc: { textAlign: "center", width: "263px", fontSize: "14px", mt: 2 },
        sep: { m: 1, fontSize: "14px" },
        rfqbtn: {
            borderRadius: "20px",
            padding: "10px 20px",
            border: "1px solid #0047A4",
            textTransform: "none",
            display: "flex",
            alignItems: "center",
        },
        icon: { color: "#0047A4" },
        btn: { color: "#0047A4", fontSize: "14px", fontWeight: 700 },
        card: { borderRadius: "10px", width: rfq !== undefined ? "90%" : "96%", overflow: "scroll", p: rfq !== undefined && 2 },
        imgbox: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#07D6E5',
            padding: '8px',

        },
        delbox: { ml: 2, width: '70%' },
        listbox: {
            display: 'flex',
            alignItems: 'center',
            padding: '12px',
            borderRadius: 2,
            boxShadow: cart ? "" : '0px 2px 5px rgba(0, 0, 0, 0.1)',
        },
        media: { width: 70, height: 70, borderRadius: 1, marginRight: '12px' },
        content: { padding: 0, minWidth: "150px" },
        cardtypo: {
            fontSize: '14px', fontWeight: 'bold', textAlign: "start", whiteSpace: 'nowrap',   // Prevent wrapping
            overflow: 'hidden',    // Hide overflow
            textOverflow: 'ellipsis', // Add ellipsis
            maxWidth: '150px',
        },
        descbox: {
            display: "flex",
            flexWrap: "wrap"
        },
        desctypo: { fontSize: '12px', color: 'gray', whiteSpace: 'nowrap', maxWidth: "80%" },
        iconbox: { width: "100%", display: "flex", justifyContent: "end" },
        editbox: {
            padding: 2,
            pt: 0,
            display: "flex",
            flexDirection: "column",
            textAlign: "start"
        },
        qty: { fontWeight: 600, textTransform: "capitalize", },
        input: { display: "flex", mt: 1 },
        btnbox: { display: "flex", mt: 2, gap: 2 },
        attachtypo: { fontWeight: 700, textAlign: "start" },
        attachbox: { border: "1px solid gray", mt: 2, mb: 2, p: 1, borderRadius: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }
    }
}

const DragDropArea = styled(Box)(({ theme }) => ({
    border: "2px dashed #00ACC1",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "200px",
    padding: theme.spacing(2),
    backgroundColor: "#F9FAFB",
    cursor: "pointer",
    maxHeight: '95px', border: "2px dashed  #9CA6A8"
}));

const ModalContent = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: 24,
    overflow: "hidden",
    minWidth: "754px", maxHeight: "382px"
}));

const Header = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    textAlign: "center",
    backgroundColor: "#07D6E5", textAlign: "start"
}));

const rfq = {
    typo: { color: "black", fontWeight: 700 },
    dragbox: { padding: "16px", bgcolor: "#F0F0F0" },
    attach: { fontSize: 30, color: "#0047A4" },
    input: {
        position: "absolute",
        opacity: 0,
        width: "100%",
        height: "100%",
        cursor: "pointer",
    },
    filebox: { bgcolor: "lightGray", mt: 2, pl: 2, borderRadius: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" },
    icon: { color: "red" },
    btnbox: { display: "flex", justifyContent: "flex-end", mt: 3 },
    backbtn: { border: "2px solid black", color: "black", width: "15%", borderRadius: "10px" },
    confirmbtn: { width: "15%", borderRadius: "10px", ml: 2, bgcolor: "black", color: "white" }
}


const Styles = {
    Header,
    ModalContent,
    DragDropArea,
    HeaderStyle,
    FooterStyle,
    Footer2Style,
    LoginStyle,
    rfq,
    LeftimgStyle,
    middleBoxStyle,
    input,
    btnstyle,
    backbtn,
    profileStyle,
    InfoStyle,
    buymaterial,
    sidebar,
    products,
    productsdetails,
    select,
    empty,
    viewcart,
    order,
    cart
}

export default Styles